export const locale = {
	lang: 'en',
	data: {
		'LOGIN': {
			'TITLE': 'Sign in',
			'REMEMBER_ME': 'Remember me',
			'FORGOT_PASSWORD': 'Password forgotten?'
		},
		'FORGOT_PASSWORD': {
			'DESCRIPTION': 'Enter your email address: we will send you a link to set a new password.',
			'EMAIL': 'Email',
			'SEND': 'Send link',
			'SENT': 'We have sent you an email with the instructions to reset your password.',
			'BACK_TO_LOGIN': 'Back to login',
			'ERROR': {
				'EMAIL_REQUIRED': 'Email is required',
				'EMAIL_INVALID': 'Please enter a valid email address',
				'GENERIC': 'Could not send the password reset email'
			}
		},
		'RESET_PASSWORD': {
			'TITLE': 'Set a new password',
			'PASSWORD': 'Password',
			'PASSWORD_CONFIRMATION': 'Confirm password',
			'SAVE': 'Save',
			'SUCCESS': 'Password changed',
			'BACK_TO_LOGIN': 'Back to login',
			'ERROR': {
				'PASSWORD_REQUIRED': 'Password is required',
				'PASSWORD_MISMATCH': 'The two passwords do not match',
				'INVALID_LINK': 'Invalid or incomplete link: please request a new password reset email.',
				'GENERIC': 'Could not change the password'
			}
		},
		'NAV': {
			'HOME': {
				'TITLE': 'Dashboard'
			},
			'CALENDAR': {
				'TITLE': 'Calendar'
			},
			'REVIEWS': {
				'TITLE': 'Reviews'
			},
			'SERVER_RT_GROUP': {
				'TITLE': 'RT Server',
				'PAYMENT_MAPPINGS': {
					'TITLE': 'Payment mapping'
				},
				'VAT_MAPPINGS': {
					'TITLE': 'VAT mapping'
				},
				'PAYMENT_METHOD_CATALOG': {
					'TITLE': 'Payment methods'
				}
			},
			'PACKAGES': {
				'TITLE': 'Packages'
			},
			'PRODUCTS': {
				'TITLE': 'Products'
			},
			'RESOURCES': {
				'TITLE': 'Resources'
			},
			'DOCUMENTS': {
				'TITLE': 'Documents'
			},
			'ASSISTANT_USAGE': {
				'TITLE': 'AI usage'
			},
			'STATISTICS': {
				'TITLE': 'BI Statistics'
			},
			'PLAFOND': {
				'TITLE': 'Plafond',
			},
			'BOOKINGS': {
				'TITLE': 'Bookings',

				'NEWBOOKING' : {
					'TITLE': 'New Booking'
				}
			},
			'MEETING_POINTS': {
				'TITLE': 'Meeting Points'
			},
			'DESTINATIONS': {
				'TITLE': 'Destinations'
			},
			'CATEGORIES': {
				'TITLE': 'Categories'
			},
			'INFO': {
				'TITLE': 'Useful Info'
			},
			'PRICES_SERVICES': {
				'TITLE': 'Prices & Services'
			},
			'ENTITIES': {
				'TITLE': 'Entities',

				'CUSTOMERS': {
					'TITLE': 'Customers'
				},
				'SUPPLIERS': {
					'TITLE': 'Suppliers'
				},
				'TOUR_OPERATORS': {
					'TITLE': 'Tour Operators'
				},
				'STAFF': {
					'TITLE': 'Staff'
				},
				'ALL': {
					'TITLE': 'All'
				}
			},
			'MARKETPLACE': {
				'TITLE': 'Marketplace',

				'TANGERINE': {
					'TITLE': 'Tangerine',
				},
				'TOURCMS': {
					'TITLE': 'Tourcms',
				},
				'BOKUN': {
					'TITLE': 'Bokun'
				},
				'TICKETLANDIA': {
					'TITLE': 'Ticketlandia',
				}
			},
			'DEFINITIONS': {
				'TITLE': 'Definizioni',
			},
			'DOMAINS_GROUP': {
				'TITLE': 'Domains Group',

				'DOMAINS': {
					'TITLE': 'Domains'
				},
				'USER_DOMAINS': {
					'TITLE': 'User Domains'
				},
				'BRANCHES': {
					'TITLE': 'Branches'
				},
				'PAYMENTS_TYPE': {
					'TITLE': 'Payments type'
				},
				'REQUESTS_TRANSFERS': {
					'TITLE': 'Requests & Transfers'
				}
			},
			'ADMIN_GROUP': {
				'TITLE': 'Super Admin',

				'USERS': {
					'TITLE': 'Users'
				},
				'DOMAIN_INFO': {
					'TITLE': 'Domain information',
				},
				'TURNOVER_REPORT': {
					'TITLE': 'Turnover Report'
				},
				'PRACTICES': {
					'TITLE': 'Sale Operations'
				},
				'TRANSMISSIONS': {
					'TITLE': 'Transmissions'
				},
				'UTILITIES': {
					'TITLE': 'Utilities'
				},
				'API': {
					'TITLE': 'API credentials generation'
				},
				'LOGS': {
					'TITLE': 'Logs'
				}
			},
			'CRITERIA': {
				'TITLE': 'Criteria',
			},
			'SERVICES': {
				'TITLE': 'Services',
			},
			'PRICE_LISTS': {
				'TITLE': 'Price Lists'
			},
			'DISCOUNTS': {
				'TITLE': 'Discounts',
			}
		},
		// common words
		'DETAIL': 'detail',
		'LIST': 'list',
		'WELCOME_BACK': 'Welcome Back',
		'Si': 'Yes',
		'Annulla': 'Cancel',
		'Ok': 'Ok',
		'Azione in corso...': 'Action in progress...',
		'Chiudi': 'Close',
		'Crea': 'Create',
		'Cerca': 'Search',
		'Carica un file': 'Upload file',
		'Aggiungi': 'Add',
		'Invia': 'Send',
		'Modifica': 'Edit',
		'Rivendi Pacchetto': 'Resell Package',
		'Blocco non configurato': 'Block not configured',
		'Questa traduzione non è ancora presente!': 'This translation is not yet present!',
		'Questa traduzione non è presente!': 'This translation is missing!',
		'Salva e vai avanti': 'Save and move on',
		'Salva': 'Save',
		'Ruolo di tipo amministrativo, accesso completo al pannello.': 'Administrative role, full access to the panel.',
		'Accesso Vietato': 'Access Denied',
		'Può visualizzare': 'Can view',
		'Può aggiungere e modificare': 'Can add and edit',
		'Accesso completo': 'Full access',
		'Esportazione': 'Export',
		'Nessuna immagine di copertina': 'No cover image',
		'Immagini': 'Images',
		'Informazioni Utili': 'Useful information',
		'Immagine di copertina': 'Cover image',
		'Lista di punti di ritrovo': 'Meeting point list',
		'invia': 'send',
		'Listino prezzi': 'Price list',
		'chiudi': 'close',
		'Seleziona i pacchetti da richiedere': 'Select the packages to request',
		'Attendi...': 'Wait...',
		'Seleziona un dominio sul quale agire': 'Select a domain to act on',
		'Seleziona': 'Select',
		'Conferma': 'Confirm',
		'Aggiungi partecipanti': 'Add participants',
		'Genera': 'Generates',
		'Rimuovi': 'Remove',
		'Ripristina': 'Reset',
		'Assegna': 'Assign',
		'Genera Partenze': 'Generate Departures',
		'Valutazione media e recensioni negative totali per anno di revisione': 'Average rating and total negative reviews per year of review',
		'Seleziona dominio': 'Select domain',
		'Calendario': 'Calendar',
		'Categorie': 'Categories',
		'Pacchetti': 'Packages',
		'Biglietti': 'Tickets',
		'Modifica Profilo': 'Edit Profile',
		'Modifica Password': 'Change Password',
		'Codice / Stato': 'Code / Status',
		'Traduzioni Atttive': 'Active Translations',
		'Nessun elemento presente': 'No items present',
		'Filtri': 'Filters',
		'Presenze': 'Attendance',
		'Sospendi prenotazione': 'Suspend booking',
		'Disponibilità': 'Availability',
		'Prenotazioni Dal': 'Bookings From',
		'Prenotazioni Al': 'Bookings At',
		'Partenza Dal': 'Departures From',
		'Partenze Fino Al': 'Departures At',
		'Risorsa': 'Resource',
		'Categoria': 'Category',
		'Codice Voucher Operatore': 'Operator Voucher Code',
		'Id Ordine Esterno': 'id External Order',
		'Nominativo': 'Nominative',
		'Utente': 'User',
		'Coupon Sconto': 'Discount Coupon',
		'Origine': 'Origin',
		'Mostra Scadute (Solo Api)': 'Show Expired (Api Only)',
		'Scrivi per cercare': 'Type to search',
		'Filtri ricerca': 'Search filters',
		'Applica': 'Apply',
		'Contatti': 'Contacts',
		'Pubblico Sul Sito': 'Publish On Site',
		'Punto Di Ritrovo': 'Meeting point',
		'Tipologia Risorsa': 'Resource Type',
		'Proprietà': 'Property',
		'Mostra Eliminati': 'Show deleted',
		'Pacchetto': 'Package',
		'Informazioni <br>Base': 'Basic <br>Information',
		'Informazioni Base': 'Basic Information',
		'Avanzate': 'Advance',
		'Descrizioni': 'Description',
		'Partenze': 'Departures',
		'Servizi e prezzi': 'Services and prices',
		'Integrazioni': 'Integrations',
		'Nessuna immagine inserita': 'No images inserted',
		'Prezzo': 'Price',
		'Nessuna traduzione attiva': 'No active translations',
		'Opzionale, se non inserito verrà generato automaticamente.': 'Optional, if not entered it will be generated automatically.',
		'Nome del pacchetto': 'Package name',
		'Pubblica Sul Sito': 'Publish On Site',
		'Priorità': 'Priority',
		'Fiscalità': 'Taxation',
		'Commissioni %': 'Commissions %',
		'Commessa': 'Shop assistant',
		'Scrivi per cercare una commessa': 'Write to look for a shop assistant',
		'Durata Standard In Ore': 'Standard Duration In Hours',
		'Bambini Da':  'Children From',
		'Adulto Da': 'Adult From',
		'Senior Da': 'Senior From',
		'Opzionale': 'Optional',
		'Dettaglio risorsa': 'Resource detail',
		'Orario': 'Hours',
		'Lista': 'List',
		'Risorse': 'Resources',
		'Punti di ritrovo': 'Meeting Points',
		'Punti Di Ritrovo': 'Meeting Points',
		'Aggiungi Risorsa': 'Add Resource',
		'Scrivi per cercare una risorsa': 'Type to search for a resource',
		'Lista Punti Di Ritrovo': 'Meeting Points List',
		'Scrivi per cercare una destinazione': 'Type to search for a destination',
		'Destinazione': 'Destination',
		'Aggiungi una Destinazione al pacchetto': 'Add a Destination to the package',
		'Nuovo Punto di ritrovo': 'New meeting point',
		'Scrivi per cercare un punto di ritrovo': 'Write to find a meeting point',
		'Optionale, puoi aggiungere un punto di ritrovo senza orario': 'Optionally, you can add an untimed meeting point',
		'Nota': 'Note',
		'Nuovo Categoria': 'New Category',
		'Scrivi per cercare una categoria': 'Write to search for a category',
		'Priorità Totem': 'Priority Totem',
		'Pubblico': 'Public',
		'Descrizione Completa': 'Full Description',
		'Testo completo di descrizione.': 'Full description text.',
		'Breve Descrizione': 'Short description',
		'Prima Di Partire': 'Before leaving',
		'Servizi Inclusi': 'Services included',
		'Servizi Esclusi': 'Services Excluded',
		'Testo Voucher Pdf': 'Text Voucher Pdf',
		'Questo testo verrà stampato sul voucher': 'This text will be printed on the voucher',
		'Testo Voucher Ticketing': 'Text Voucher Ticketing',
		'Indietro': 'Back',
		'Lista Punti Di Ritorno': 'Return Points List',
		'Data Inizio Partenze': 'Start Date Departures',
		'Data Fine Partenze': 'Departure End Date',
		'Durata In Ore': 'Duration In Hours',
		'Giorno Della Settimana': 'Day of the week',
		'Allotment Minimo': 'Minimum allotments',
		'Allotment Specifico': 'Specific Allotments',
		'Stato Partenza': 'Status Departure',
		'Lingua': 'Language',
		'Lingua Con Audioguida': 'Language With Audioguide',
		'Da': 'From',
		'Fino A': 'To',
		'Crea Servizio': 'Create Service',
		'Servizio Primario': 'Primary Service',
		'Codice Servizio': 'Service Code',
		'Codice Criterio': 'Policy Code',
		'Descrizione Criterio': 'Description Policy',
		'Prezzo Al Pubblico': 'Retail price',
		'Listino Prezzi': 'Price list',
		'Non attivo': 'Inactive',
		'Attivo': 'Active',
		'Tipo / Tipologia': 'Type / Typology',
		'Tipo Risorsa': 'Resource type',
		'Tipologia': 'Typology',
		'Tipo Allotment': 'Allotments type',
		'Partecipanti': 'Participants',
		'Codice prenotazione': 'Booking code',
		'Età': 'Age',
		'Gestione presenza': 'Presence management',
		'Ultimo check': 'Last check',
		'Conferma presenti': 'Mark as present',
		'Marca assenti': 'Mark as absent',
		'selezionati': 'selected',
		'Nessun partecipante': 'No participants',
		'Errore caricamento partecipanti': 'Error loading participants',
		'Errore aggiornamento presenza': 'Error updating presence',
		'Errore aggiornamento massivo': 'Bulk update error',
		'Presenza confermata': 'Presence confirmed',
		'Presenza non confermata': 'Presence not confirmed',
		'Presenza rimossa': 'Presence removed',
		'Mostra log': 'Show log',
		'Nessun log disponibile': 'No log available',
		'Log partecipante': 'Participant log',
		'Errore caricamento log': 'Error loading log',
		'Creazione': 'Creation',
		'Cancellazione': 'Deletion',
		'Azione': 'Action',
		'Richiesta': 'Request',
		// assistente AI
		'Assistente': 'Assistant',
		'Controllo cosa stai guardando…': 'Checking what you are looking at…',
		'Apri il dettaglio di un pacchetto per lavorare su criteri e prezzi.': 'Open a package to work on its price criteria and prices.',
		'Chiedi in linguaggio naturale: prima di modificare qualcosa ti mostro il riepilogo da confermare.': 'Ask in plain language: before changing anything I show you a summary to confirm.',
		'Che regole di prezzo ha questo pacchetto?': 'Which price rules does this package have?',
		'Crea un prezzo per Adulti dal 09/06/2026 con un prezzo di 150€': 'Create an Adult price of €150 from 09/06/2026',
		'Aumenta del 15% il prezzo nei weekend di agosto': 'Increase the price by 15% on August weekends',
		'Scrivi una domanda per iniziare.': 'Write a question to get started.',
		'Riprova': 'Try again',
		'Messaggio per l\'assistente': 'Message for the assistant',
		'Scrivi una richiesta': 'Write a request',
		'Viaggi dal': 'Trips from',
		'Viaggi fino al': 'Trips until',
		'Prenotazioni dal': 'Bookings from',
		'Prenotazioni fino al': 'Bookings until',
		'Per prenotazioni': 'For bookings',
		'Nome': 'Name',
		'Mostra tutte le modifiche': 'Show all changes',
		'Nessun dato è stato ancora modificato.': 'Nothing has been changed yet.',
		'Applicata alle': 'Applied at',
		'Annullata: nessuna modifica applicata.': 'Cancelled: no changes applied.',
		'Proposta scaduta: chiedi di nuovo all\'assistente.': 'Proposal expired: ask the assistant again.',
		'La modifica non è stata applicata.': 'The change was not applied.',
		'Assistente AI': 'AI assistant',
		'Ecco cosa noto guardando i prezzi di oggi. Tocca un consiglio o scrivi tu: prima di modificare qualcosa ti mostro il riepilogo da confermare.': 'Here is what I notice in today\'s prices. Tap a suggestion or write your own: before changing anything I show you a summary to confirm.',
		'Ecco cosa noto guardando testi, pacchetti e visibilità. Tocca un consiglio o scrivi tu: prima di modificare qualcosa ti mostro il riepilogo da confermare.': 'Here is what I notice in texts, packages and visibility. Tap a suggestion or write your own: before changing anything I show you a summary to confirm.',
		'Ecco cosa noto confrontando destinazioni e categorie con la descrizione. Tocca un consiglio o scrivi tu: prima di modificare qualcosa ti mostro il riepilogo da confermare.': 'Here is what I notice comparing destinations and categories with the description. Tap a suggestion or write your own: before changing anything I show you a summary to confirm.',
		'Ecco cosa noto guardando i testi di vendita. Tocca un consiglio o scrivi tu: prima di modificare qualcosa ti mostro il riepilogo da confermare.': 'Here is what I notice in the sales texts. Tap a suggestion or write your own: before changing anything I show you a summary to confirm.',
		'Sto guardando il pacchetto per consigli più precisi…': 'Looking at the package for more precise suggestions…',
		'Tabella con {{rows}} righe e {{columns}} colonne': 'Table with {{rows}} rows and {{columns}} columns',
		'Tabella con 1 riga e {{columns}} colonne': 'Table with 1 row and {{columns}} columns',
		'Apri la tabella': 'Open the table',
		'Titolo': 'Title',
		'Breve descrizione': 'Short description',
		'Descrizione completa': 'Full description',
		'Servizi inclusi': 'Included services',
		'Servizi esclusi': 'Excluded services',
		'Prima': 'Before',
		'Aggiunto': 'Added',
		'Tolto': 'Removed',
		'Elenco svuotato': 'List emptied',
		'Testo svuotato': 'Text emptied',
		'Colore tolto': 'Colour removed',
		'diventa': 'becomes',
		'Leggi tutto': 'Read all',
		'Riduci': 'Show less',
		'Confronta con il testo attuale': 'Compare with the current text',
		'Nascondi il testo attuale': 'Hide the current text',
		'Visibile subito su sito e widget': 'Visible right away on website and widget',
		'Salvata ma nascosta su sito e widget': 'Saved but hidden on website and widget',
		'Diventa visibile su sito e widget': 'Becomes visible on website and widget',
		'Viene nascosta su sito e widget': 'Gets hidden on website and widget',
		'Vedi tutte le {{count}} righe': 'See all {{count}} rows',
		'Apri in grande': 'Open full size',
		'Tabella': 'Table',
		'Copia per Excel': 'Copy for Excel',
		'Copiata': 'Copied',
		'Da eliminare': 'To delete',
		'Elimina': 'Delete',
		'eliminato': 'deleted',
		'Chiedi all\'assistente': 'Ask the assistant',
		'Ritirata dall\'assistente: nessuna modifica applicata.': 'Withdrawn by the assistant: no change applied.',
		// consumi assistente AI
		'Consumi dell\'assistente AI': 'AI assistant usage',
		'Periodo': 'Period',
		'Ultimi 7 giorni': 'Last 7 days',
		'Ultimi 30 giorni': 'Last 30 days',
		'Questo mese': 'This month',
		'Mese scorso': 'Last month',
		'Dal – al': 'From – to',
		'Inizio': 'Start',
		'Fine': 'End',
		'L\'assistente è spento per questa azienda: qui sotto trovi lo storico dei consumi.': 'The assistant is off for this company: below is the usage history.',
		'Budget del periodo': 'Budget for the period',
		'spesi su': 'spent of',
		'Budget esaurito: l\'assistente è in pausa fino all\'azzeramento.': 'Budget used up: the assistant is paused until the reset.',
		'token usati su': 'tokens used of',
		'Token per periodo': 'Tokens per period',
		'Restano': 'Left',
		'spesi, senza limite di budget': 'spent, no budget limit',
		'Il budget non è disponibile: il servizio AI non ha risposto. I consumi qui sotto sono aggiornati.': 'The budget is not available: the AI service did not respond. The usage below is up to date.',
		'Si azzera oggi': 'Resets today',
		'Si azzera domani, {{date}}': 'Resets tomorrow, {{date}}',
		'Si azzera il {{date}}, tra {{days}} giorni': 'Resets on {{date}}, in {{days}} days',
		'Richieste': 'Requests',
		'Token usati': 'Tokens used',
		'in ingresso': 'input',
		'generati': 'generated',
		'Costo': 'Cost',
		'Utenti attivi': 'Active users',
		'Token per giorno': 'Tokens per day',
		'Token usati per giorno nel periodo': 'Tokens used per day in the period',
		'{{date}}: nessuna richiesta': '{{date}}: no requests',
		'{{date}}: 1 richiesta, {{tokens}} token': '{{date}}: 1 request, {{tokens}} tokens',
		'{{date}}: {{requests}} richieste, {{tokens}} token': '{{date}}: {{requests}} requests, {{tokens}} tokens',
		'Nessun utilizzo in questo periodo.': 'No usage in this period.',
		'Chi lo usa': 'Who uses it',
		'richiesta': 'request',
		'richieste': 'requests',
		'ultima': 'last',
		'Oggi, {{time}}': 'Today, {{time}}',
		'Ieri, {{time}}': 'Yesterday, {{time}}',
		'Nessuno ha usato l\'assistente in questo periodo.': 'Nobody used the assistant in this period.',
		'Attività': 'Activity',
		'Tutti gli utenti': 'All users',
		'Richiesta senza testo': 'Request without text',
		'Criterio': 'Criterion',
		'Altra schermata': 'Other screen',
		'Applicata': 'Applied',
		'Annullata': 'Canceled',
		'Non riuscita': 'Failed',
		'Scaduta': 'Expired',
		'In attesa': 'Pending',
		'chiamata al modello': 'model call',
		'chiamate al modello': 'model calls',
		'Questo utente non ha fatto richieste nel periodo.': 'This user made no requests in the period.',
		'Le richieste fatte all\'assistente compariranno qui, con chi le ha fatte e quanti token hanno usato.': 'Requests made to the assistant will appear here, with who made them and how many tokens they used.',
		'del budget del periodo usato': 'of the budget used this period',
		'Disponibile ancora il': 'Still available:',
		'token usati nel periodo, senza limite di budget': 'tokens used in the period, no budget limit',
		'Token per richiesta': 'Tokens per request',
		'I consumi non sono stati caricati: controlla la connessione e riprova.': 'Usage could not be loaded: check your connection and try again.',
		'Non hai accesso ai consumi di questa azienda.': 'You do not have access to this company\'s usage.',
		'I consumi dell\'assistente sono visibili solo agli amministratori dell\'azienda.': 'Assistant usage is visible only to the company\'s administrators.',
		'Seleziona un\'azienda per vedere i consumi dell\'assistente.': 'Select a company to see the assistant usage.',
		'Assistente AI: proposte da confermare': 'AI assistant: proposals to confirm',
		'Nuova chat': 'New chat',
		'Sto guardando': 'Looking at',
		'Sto pensando': 'Thinking',
		'File allegati': 'Attached files',
		'File da inviare': 'Files to send',
		'riga': 'line',
		'righe': 'lines',
		'Lettura…': 'Reading…',
		'Togli': 'Remove',
		'Allega un file con le istruzioni (txt, csv, Excel, Word)': 'Attach a file with instructions (txt, csv, Excel, Word)',
		'Rilascia il file per allegarlo': 'Drop the file to attach it',
		'Formato non supportato: usa txt, md, csv, Excel o Word': 'Unsupported format: use txt, md, csv, Excel or Word',
		'File troppo grande: massimo 5 MB': 'File too large: 5 MB maximum',
		'Sto lavorando alla risposta': 'Working on the answer',
		'Invio per inviare, Maiusc+Invio per andare a capo': 'Enter to send, Shift+Enter for a new line',
		'Prezzi gestiti con l\'assistente AI': 'Prices managed with the AI assistant',
		'Questi prezzi sono stati impostati con l\'assistente: per tenerli coerenti si modificano solo da lì. Aggiunta, modifica ed eliminazione manuali sono disattivate.': 'These prices were set with the assistant: to keep them consistent they can only be changed there. Manual add, edit and delete are disabled.',
		'Apri l\'assistente': 'Open the assistant',
		'Torna alla gestione manuale': 'Back to manual management',
		'Tornare alla gestione manuale?': 'Back to manual management?',
		'Codice': 'Code',
		'Se non attivo, questo utente non vede l\'assistente AI.': 'When off, this user does not see the AI assistant.',
		'Disattivato': 'Off',
		'Se attivo, gli utenti abilitati trovano l\'assistente nelle schermate dei prezzi dei pacchetti.': 'When on, enabled users find the assistant on the package price screens.',
		'Budget per periodo (USD)': 'Budget per period (USD)',
		'Vuoto = nessun limite. Raggiunto il budget, l\'assistente si ferma fino all\'azzeramento.': 'Empty = no limit. Once the budget is reached the assistant stops until it resets.',
		'Azzeramento del budget': 'Budget reset',
		'Ogni giorno': 'Every day',
		'Ogni settimana': 'Every week',
		'Ogni 30 giorni': 'Every 30 days',
		'Ogni mese': 'Every month',
		'Conservazione delle conversazioni': 'Conversation retention',
		'Le conversazioni senza nuovi messaggi da più di questo periodo vengono cancellate ogni notte. I consumi restano.': 'Conversations with no new messages for longer than this period are deleted every night. Usage is kept.',
		'30 giorni': '30 days',
		'60 giorni': '60 days',
		'90 giorni': '90 days',
		'6 mesi': '6 months',
		'1 anno': '1 year',
		'Conversazione cancellata dopo il periodo di conservazione': 'Conversation deleted after the retention period',
		'Modifica Assistente AI': 'Edit AI assistant',
		'Adulti': 'Adults',
		'Bambini': 'Children',
		'Infant': 'Infants',
		'Senior': 'Seniors',
		'I prezzi resteranno quelli attuali e tornerai a modificarli dalle schermate del pacchetto. Se poi li modifichi di nuovo con l\'assistente, la gestione manuale verrà bloccata di nuovo.': 'Prices stay as they are and you will edit them from the package screens again. If you change them with the assistant later, manual management will be locked again.'
	}
};
